const readCsrfToken = () => {
  const csrfTokenEl = document.querySelector('meta[name="csrf-token"]');
  return (csrfTokenEl && csrfTokenEl.getAttribute("content")) || "";
};
export default readCsrfToken;
